/** Real AI provider logos (same sources as legacy LandingPage). */
export function getTrustLogos(darkMode) {
  const mono = darkMode ? "ffffff" : "000000";
  return [
    {
      src: `https://cdn.simpleicons.org/openai/${mono}`,
      alt: "ChatGPT / OpenAI",
      name: "ChatGPT",
      fallback: darkMode ? "/openai-icon-white.svg" : "/openai-icon.svg",
    },
    {
      src: `https://cdn.simpleicons.org/claude/${mono}`,
      alt: "Claude",
      name: "Claude",
      fallback: `https://cdn.simpleicons.org/anthropic/${mono}`,
    },
    {
      src: `https://cdn.simpleicons.org/googlegemini/${mono}`,
      alt: "Google Gemini",
      name: "Gemini",
    },
    {
      src: `https://cdn.simpleicons.org/perplexity/${mono}`,
      alt: "Perplexity AI",
      name: "Perplexity",
    },
    { src: "/grok-icon.jpeg", alt: "Grok (xAI)", name: "Grok" },
  ];
}
